import { getBookmarks } from '../core';
import { log, pageWasReloaded } from '../helpers';
import {
  LOCAL_STORAGE_KEY,
  LOCAL_STORAGE_KEY_EXPIRES,
  LOG_PREFIX,
} from '../resources';

export const cleanLocalBookmarks = () => {
  localStorage.removeItem(LOCAL_STORAGE_KEY);
  localStorage.removeItem(LOCAL_STORAGE_KEY_EXPIRES);
};

// in order to decrease load on the bookmark endpoint for article pages, check local storage or update it.
export const updateOrRetrieveBookmarkEvents = async (pageType: PageType) => {
  let eventList;
  const storedBookmarks = getLocalBookmarkEvents();
  const storedExpiration = localStorage.getItem(LOCAL_STORAGE_KEY_EXPIRES);
  const storageExpired = storedExpiration
    ? new Date(storedExpiration) < new Date(Date.now())
    : true;

  if (
    pageWasReloaded ||
    !storedBookmarks ||
    storageExpired ||
    pageType === 'list'
  ) {
    const bookmarkBody = await getBookmarks();
    eventList = bookmarkBody.bookmarkEvents;
    renewExpirationDate();
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(eventList));
  } else {
    // ordinary pageviews should query local bookmarks.
    eventList = storedBookmarks;
  }
  return eventList;
};

export const setLocalBookmarks = (bookmarks: BookmarkEvent[]) => {
  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(bookmarks));
};

export const renewExpirationDate = () => {
  const expiryDurationInMs = 24 * 60 * 60 * 1000; //1 day
  const momentOfExpiryAsTimeStamp = Date.now() + expiryDurationInMs;
  const expirationMomentToStore = new Date(
    momentOfExpiryAsTimeStamp
  ).toISOString();
  localStorage.setItem(LOCAL_STORAGE_KEY_EXPIRES, expirationMomentToStore);

  log(
    `storage expiration date set, expires on ${new Date(
      momentOfExpiryAsTimeStamp
    ).toLocaleString()}, stored as ${expirationMomentToStore}`
  );
};

// Get local bookmarks if they exist.
export const getLocalBookmarkEvents = (): BookmarkEvent[] | null => {
  const savedData = localStorage.getItem(LOCAL_STORAGE_KEY);
  let parsed = null;

  if (!savedData) {
    log(
      `${LOG_PREFIX} "${LOCAL_STORAGE_KEY}" in local storage could not be found.\n`
    );
    return null;
  }

  //always try to parse as a quality check.
  try {
    parsed = JSON.parse(savedData);
  } catch (e) {
    log(
      `${LOG_PREFIX} ${LOCAL_STORAGE_KEY} in local storage could not be parsed:\n`,
      savedData
    );
    return null;
  }

  return parsed;
};
